import React from "react";
import { Box } from "@mui/material";
import { fonts, colors } from "../../theme/tokens";
import { sectors } from "../../data/siteData";

const SectorMarquee = () => {
  const loop = [...sectors, ...sectors];
  return (
    <Box
      component="section"
      sx={{
        py: { xs: "8px 0 28px", md: "8px 0 28px" },
        pt: "8px",
        pb: "28px",
        overflow: "hidden",
        "@keyframes marquee": {
          from: { transform: "translateX(0)" },
          to: { transform: "translateX(-50%)" },
        },
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          fontFamily: fonts.display,
          fontSize: "12px",
          letterSpacing: ".22em",
          color: colors.subtleText,
          fontWeight: 600,
          mb: "22px",
        }}
      >
        SECTORS WE SERVE ACROSS THE ECONOMY
      </Box>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          width: "100%",
          maskImage:
            "linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)",
          WebkitMaskImage:
            "linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "54px",
            pr: "54px",
            whiteSpace: "nowrap",
            animation: "marquee 26s linear infinite",
          }}
        >
          {loop.map((s, i) => (
            <Box
              key={i}
              sx={{
                fontFamily: fonts.display,
                fontWeight: 600,
                fontSize: "21px",
                color: "#B3BCC7",
                letterSpacing: "-.01em",
              }}
            >
              {s}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectorMarquee;
